// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-354143e6]{display:none}.copyright[data-v-354143e6]{color:var(--c-light-06);display:flex;flex-direction:column;font-size:14px;justify-content:center;line-height:24px;padding:20px;text-align:center}@media(min-width:768px){.copyright[data-v-354143e6]{-moz-column-gap:6px;column-gap:6px;flex-direction:row}}.copyright a[data-v-354143e6]:hover{color:var(--c-white)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
